export interface InfoboothsEntity {
  uuid: string
  auction: string
  name: string
  content: string
  display: boolean
  order: number
}

export enum InfoboothDialogFunctionEnum {
  Update = 'update',
  Create = 'create',
}

export const INFOBOOTHS_LOADER = {
  deleteInfobooth: {
    id: 'deleteInfobooth',
    message: 'LOADER.DELETING_INFOBOOTH',
  },
}
